'use client';

import { type ComponentProps, useState } from 'react';

import Link from 'next/link';

type LinkProps = ComponentProps<typeof Link>;

/**
 * next/link for customer pages, with automatic prefetch only for bare /book.
 *
 * /book keeps the default prefetch; other customer links wait for intent.
 * An explicit `prefetch` prop still wins.
 */
export default function TenantLink({
  prefetch,
  onFocus,
  onMouseEnter,
  onTouchStart,
  ...props
}: LinkProps) {
  const [intentHref, setIntentHref] = useState<string | null>(null);
  const hrefKey = JSON.stringify(props.href);
  const isBook = typeof props.href === 'string'
    ? props.href.split(/[?#]/)[0] === '/book'
    : props.href.pathname === '/book';
  const isBareBook = typeof props.href === 'string'
    ? props.href === '/book'
    : isBook && !props.href.search && !props.href.hash &&
      (!props.href.query || Object.keys(props.href.query).length === 0);
  const intentPrefetch = intentHref === hrefKey;

  return (
    <Link
      {...props}
      prefetch={prefetch !== undefined ? prefetch : isBareBook || intentPrefetch ? undefined : false}
      onFocus={(event) => {
        setIntentHref(hrefKey);
        onFocus?.(event);
      }}
      onMouseEnter={(event) => {
        setIntentHref(hrefKey);
        onMouseEnter?.(event);
      }}
      onTouchStart={(event) => {
        setIntentHref(hrefKey);
        onTouchStart?.(event);
      }}
    />
  );
}
